import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../api.service';
import { LocalizableComponent } from '../../components/localizable/localizable.component';

@Component({
    selector: 'cancel-request-modal',
    templateUrl: './cancel-request-modal.component.html',
    styleUrls: ['./cancel-request-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelRequestModal extends LocalizableComponent {
@Input() isNewRequest: boolean;

  constructor(private apiService: ApiService, private router: Router,public activeModal: NgbActiveModal) {
    super();
  }

  goBack() {
    this.activeModal.close(true);
  }

  dismissModal() {
    this.activeModal.close(false);
  }
}
